import React from 'react'

import Advertisers from '@/app/components/PageBuilder/AdvertisersSection'
import AiDemoSection from '@/app/components/PageBuilder/AiDemoSection'
import ContactFormSection from '@/app/components/PageBuilder/ContactFormSection'
import ContentSection from '@/app/components/PageBuilder/ContentSection'
import Cta from '@/app/components/PageBuilder/CtaSection'
import DemoFormSection from '@/app/components/PageBuilder/DemoFormSection'
import FaqSection from '@/app/components/PageBuilder/FaqSection'
import HeroBanner from '@/app/components/PageBuilder/HeroBannerSection'
import Hero from '@/app/components/PageBuilder/HeroSection'
import OpenPositionsPinpoint from '@/app/components/PageBuilder/OpenPositionsPinpoint'
import PartnerQuote from '@/app/components/PageBuilder/PartnerQuote'
import ReviewSection from '@/app/components/PageBuilder/ReviewSection'
import Separator from '@/app/components/PageBuilder/SeparatorSection'
import SharedSection from '@/app/components/PageBuilder/SharedSection'
import SideBySideColumnsSection from '@/app/components/PageBuilder/SideBySideColumnsSection'
import SideBySideSection from '@/app/components/PageBuilder/SideBySideSection'
import SliderSection from '@/app/components/PageBuilder/SliderSection'
import { dataAttr } from '@/sanity/lib/utils'

type BlocksType = {
  [key: string]: React.FC<any>
}

type BlockType = {
  _type: string
  _key: string
}

type BlockProps = {
  index: number
  block: BlockType
  pageId: string
  pageType: string
  isLast?: boolean
}

const Blocks: BlocksType = {
  advertisersSection: Advertisers,
  aiDemoSection: AiDemoSection,
  contactForm: ContactFormSection,
  demoForm: DemoFormSection,
  contentSection: ContentSection,
  ctaSection: Cta,
  faqSection: FaqSection,
  heroSection: Hero,
  heroBanner: HeroBanner,
  openPositionsPinpoint: OpenPositionsPinpoint,
  partnerQuote: PartnerQuote,
  reviewSection: ReviewSection,
  separatorSection: Separator,
  sharedSectionReference: SharedSection,
  sideBySideSection: SideBySideSection,
  sideBySideColumnsSection: SideBySideColumnsSection,
  sliderSection: SliderSection,
}

/**
 * Used by the <PageBuilder>, this component renders a the component that matches the block type.
 */
export default function BlockRenderer({ block, index, pageId, pageType, isLast }: BlockProps) {
  // Block does exist
  if (typeof Blocks[block._type] !== 'undefined') {
    // Prepare props for the component
    const componentProps: any = {
      key: block._key,
      block: block,
      index: index,
      pageId: pageId,
      pageType: pageType,
      isLast: isLast,
    }

    return (
      <div
        key={block._key}
        data-sanity={dataAttr({
          id: pageId,
          type: pageType,
          path: `pageBuilder[_key=="${block._key}"]`,
        }).toString()}
      >
        {React.createElement(Blocks[block._type], componentProps)}
      </div>
    )
  }
  // Block doesn't exist yet
  return React.createElement(
    () => (
      <div className="w-full bg-gray-100 text-center text-gray-500 p-20 rounded">
        A &ldquo;{block._type}&rdquo; block hasn&apos;t been created
      </div>
    ),
    { key: block._key },
  )
}
